import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createBotsPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t('bots.columns.id'),
            value: 'id',
            key: 'id',
            align: 'start',
            sortable: true,
            nowrap: true,
            width: 40,
        },
        {
            title: t('bots.columns.name'),
            value: 'name',
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.market'),
            value: 'periodTypeId',
            key: 'periodTypeId',
            align: 'center',
            sortable: true,
            nowrap: true,
            width: 48,
        },
        {
            title: t('bots.columns.user'),
            value: 'toolUserLogin',
            key: 'toolUserLogin',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.created'),
            value: 'created_at',
            key: 'created_at',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.lastActivity'),
            value: 'last_activity_at',
            key: 'last_activity_at',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.status'),
            value: 'isActive',
            key: 'isActive',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.bets'),
            value: 'totalBetCount',
            key: 'totalBetCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.turnover'),
            value: 'totalStakeSum',
            key: 'totalStakeSum',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('bots.columns.balance'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 48,
            headerProps: { class: 'px-0' },
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
